import { render, staticRenderFns } from "./I18nTranslationDialog.vue?vue&type=template&id=6369b4a4&scoped=true&"
import script from "./I18nTranslationDialog.vue?vue&type=script&lang=js&"
export * from "./I18nTranslationDialog.vue?vue&type=script&lang=js&"
import style0 from "./I18nTranslationDialog.vue?vue&type=style&index=0&id=6369b4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369b4a4",
  null
  
)

export default component.exports